import { GridColDef } from '@mui/x-data-grid';
import { MakePartial } from '@shared/entity';
import { renderServiceEditCell } from '../../pages/price-list';

export type WorkPauseBlock = {
  type: 'work' | 'wait';
  duration: number;
};

export type Service = {
  id: string;
  serviceName: string;
  basePrice: number;
  blocks: WorkPauseBlock[];
  publicName?: string | null;
  publicDescription?: string | null;
};

export type ServiceCreateOrUpdateData = MakePartial<Service, 'id'>;

export const createServicesColumns = (
  formatPrice: (value: number) => string = value => `${value},00 CZK`,
): GridColDef<Service[][number]>[] => {
  return [
    {
      field: 'serviceName',
      headerName: 'priceList.item',
      flex: 3,
      disableColumnMenu: true,
      minWidth: 160,
    },
    {
      field: 'basePrice',
      headerName: 'priceList.price',
      flex: 3,
      disableColumnMenu: true,
      width: 120,
      renderCell: params => formatPrice(params.value),
    },
    {
      field: 'edit',
      headerName: '',
      width: 20,
      flex: 3,
      editable: false,
      display: 'flex',
      disableColumnMenu: true,
      renderCell: params => {
        const { id, basePrice, serviceName, blocks, publicDescription, publicName } = params.row;
        return renderServiceEditCell({
          id,
          basePrice,
          serviceName,
          blocks,
          publicDescription,
          publicName,
        });
      },
    },
  ];
};

export const getServiceDurationMinutes = (service: Service): number =>
  service.blocks.reduce((sum, b) => sum + b.duration, 0);
